import type { ComparePage } from "./types"

const CHECKED = "2026-10-27" // T404 matrix: docs/research/competitor-compare-2026-10.md, sections 2.1-2.3

// "Free plans at a glance" on /compare. Only cells the T404 matrix read; prices not read are left out.
export const hub: ComparePage = {
  slug: "hub",
  sources: {
    S1: {
      label: "Driversnote AU pricing",
      url: "https://www.driversnote.com.au/pricing",
      checkedAt: CHECKED,
    },
    S8: {
      label: "Everlance on the App Store (Australia)",
      url: "https://apps.apple.com/au/app/mileage-logbook-by-everlance/id985378916",
      checkedAt: CHECKED,
    },
    S13: { label: "Crunchr home", url: "https://www.crunchr.com.au/", checkedAt: CHECKED },
    S14: {
      label: "Instant Receipts home",
      url: "https://instantreceipts.com.au/",
      checkedAt: CHECKED,
    },
  },
  rows: [
    { label: "Driversnote", theirs: { value: "Up to 15 trips a month", sources: ["S1"] } },
    {
      label: "Everlance",
      theirs: { value: "Manual recording and 30 automatic trips a month", sources: ["S8"] },
    },
    { label: "Crunchr", theirs: { value: "7-day free trial, no card needed", sources: ["S13"] } },
    {
      label: "Instant Receipts",
      theirs: {
        value:
          "“30 free scans • No credit card required” on its home page. The page describes this two ways: as a trial and as a monthly allowance",
        sources: ["S14"],
      },
    },
  ],
}
